import * as React from "react";
const YellowWarningIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={21.379} height={20} {...props}>
    <path
      fill="#ffaa01"
      d="M0 20h21.379L10.689 0Zm11.835-3.075H9.544v-2.31h2.291Zm0-3.846H9.544V8.462h2.291Z"
      data-name="Icon ionic-md-warning"
    />
  </svg>
);
export default YellowWarningIcon;
